import { FirebaseAuth } from '../../../../lib/firebase'

export const emailPasswordSignIn = (
  email: string,
  password: string
): Promise<any> => FirebaseAuth.signInWithEmailAndPassword(email, password)
